/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1AgentPatch422ResponseValidationErrorsInner model module.
 * @module model/AgentV1AgentPatch422ResponseValidationErrorsInner
 * @version 1.0.0
 */
class AgentV1AgentPatch422ResponseValidationErrorsInner {
    /**
     * Constructs a new <code>AgentV1AgentPatch422ResponseValidationErrorsInner</code>.
     * @alias module:model/AgentV1AgentPatch422ResponseValidationErrorsInner
     * @param field {String} 検証対象の項目名
     * @param code {String} 検証コード。too_long・taken・invalidなど。未知のコードも返りうる。
     */
    constructor(field, code) { 
        
        AgentV1AgentPatch422ResponseValidationErrorsInner.initialize(this, field, code);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, field, code) { 
        obj['field'] = field;
        obj['code'] = code;
    }

    /**
     * Constructs a <code>AgentV1AgentPatch422ResponseValidationErrorsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1AgentPatch422ResponseValidationErrorsInner} obj Optional instance to populate.
     * @return {module:model/AgentV1AgentPatch422ResponseValidationErrorsInner} The populated <code>AgentV1AgentPatch422ResponseValidationErrorsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1AgentPatch422ResponseValidationErrorsInner();

            if (data.hasOwnProperty('field')) {
                obj['field'] = ApiClient.convertToType(data['field'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1AgentPatch422ResponseValidationErrorsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1AgentPatch422ResponseValidationErrorsInner</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentV1AgentPatch422ResponseValidationErrorsInner.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['field'] && !(typeof data['field'] === 'string' || data['field'] instanceof String)) {
            throw new Error("Expected the field `field` to be a primitive type in the JSON string but got " + data['field']);
        }
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }

        return true;
    }


}

AgentV1AgentPatch422ResponseValidationErrorsInner.RequiredProperties = ["field", "code"];

/**
 * 検証対象の項目名
 * @member {String} field
 */
AgentV1AgentPatch422ResponseValidationErrorsInner.prototype['field'] = undefined;

/**
 * 検証コード。too_long・taken・invalidなど。未知のコードも返りうる。
 * @member {String} code
 */
AgentV1AgentPatch422ResponseValidationErrorsInner.prototype['code'] = undefined;

/**
 * 文字数などの検証に用いた制約値
 * @member {Number} limit
 */
AgentV1AgentPatch422ResponseValidationErrorsInner.prototype['limit'] = undefined;






export default AgentV1AgentPatch422ResponseValidationErrorsInner;

